import { render, staticRenderFns } from "./ledgerList.vue?vue&type=template&id=62069fab&scoped=true"
import script from "./ledgerList.vue?vue&type=script&lang=ts"
export * from "./ledgerList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62069fab",
  null
  
)

export default component.exports